// import { TodoItem } from '../TodoItem';
import "./TodoList.css";

function TodoList(props) {
  return <ul>{props.children}</ul>;
}

export { TodoList };
